require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-tags-indianapolis-post-office-credit-union.json") })
        }
      }, "path---es-articles-tags-indianapolis-post-office-credit-union");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-tags-indianapolis-post-office-credit-union!./.cache/json/es-articles-tags-indianapolis-post-office-credit-union.json
// module id = 2358
// module chunks = 231608221292675